import { render, staticRenderFns } from "./AddressPopUp.vue?vue&type=template&id=660bff84&scoped=true"
import script from "./AddressPopUp.vue?vue&type=script&lang=js"
export * from "./AddressPopUp.vue?vue&type=script&lang=js"
import style0 from "./AddressPopUp.vue?vue&type=style&index=0&id=660bff84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660bff84",
  null
  
)

export default component.exports